module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAJCAYAAAD6reaeAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAZUlEQVQI112MsQmAQBAE5+W5DkRsxtBErcBAkCtFDIwMDWzD1DIsRpAz+ZfHDWeYxVRmU6lIlgElcJpKnQpMZTUVi8IlYgFGoHe/4gJyn4AJKIDhS8NnE8EWQBcrDzxA6/b7iPAFaCwjY9ujuS0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yello.png
// module id = UgNX
// module chunks = 1